import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestRaceOdds } from '../../store/raceOdds/raceOdds.thunks'
import { requestSportStart } from '../../store/eventPage/eventPage.thunks'
import { requestRacingPageData } from '../../store/racingPage/racingPage.thunks'

export const connectRacingPage = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      timeSettings: state.timeSettings,
      navigationHeaderMenu: state.navigationHeaderMenu,
      betPlacing: state.betPlacing,
      menu: state.menu,
      auth: state.auth,
      racingPage: state.racingPage,
      hrEventId: state.navigationHeaderMenu.hrEventId,
      hrMarketId: state.navigationHeaderMenu.hrMarketId,
      hrCountryCode: state.navigationHeaderMenu.hrCountryCode,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestRaceOdds,
      requestSportStart,
      requestRacingPageData
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
